<!-- =========================================================================================
    File Name: Tasks.vue
    Description: Task Application (Inbox)
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <div>
      <vx-card :title="tasksCardTitle" class="mb-5 tasks-card">
        <template slot="actions">
          <div class="flex items-center flex-wrap">
            <vs-button
              v-if="!showAllTasks"
              @click="ToggleEditPriority"
              :color="LerpColor(gradientStart, gradientEnd, 0)"
              icon-pack="feather"
              icon="icon-sliders"
              size="small"
              class="mr-1 mb-1"
            >
              {{ editPriorityMode ? 'Finish Editing Priority' : 'Edit Priority' }}
            </vs-button>
            <vs-button @click="GetTasks" icon-pack="feather" icon="icon-refresh-cw" size="small" class="mr-1 mb-1" :color="LerpColor(gradientStart, gradientEnd, showAllTasks ? 0 : 1/2)">Refresh</vs-button>
            <vs-button @click="BeginAddTask" icon="add" size="small" class="mb-1" :color="LerpColor(gradientStart, gradientEnd, showAllTasks ? 1 : 1)">Add</vs-button>
          </div>
        </template>

        <vs-table
          ref="tasksTable"
          search
          stripe
          :max-items="effectiveTasksPerPage"
          pagination
          no-data-text="No Tasks"
          :data="sortedTaskList"
          class="teTable compact"
        >
          <template slot="header">
            <div class="flex flex-wrap items-center" style="width: 100%;">
              <div class="flex flex-wrap items-center">
                <v-select
                  placeholder="Client"
                  class="tasks-client-select mr-3"
                  style="min-width: 200px; max-width: 280px;"
                  @input="OnChangedClient"
                  v-model="clientID"
                  :options="clientList"
                  :reduce="x => x.ClientID"
                  label="ClientName"
                />
                <div class="flex items-center mr-3">
                  <span class="mr-2">Show Completed</span>
                  <vs-switch v-model="showCompleted" color="primary" />
                </div>
                <div v-if="isAdmin" class="flex items-center">
                  <span class="mr-2">Show Tasks For All Users</span>
                  <vs-switch v-model="showAllTasks" @input="OnToggleAllTasks" color="primary" />
                </div>
              </div>
              <div class="flex items-center ml-auto mr-2">
                <span class="mr-2">Per Page</span>
                <v-select
                  v-model="tasksPerPage"
                  :options="tasksPerPageOptions"
                  :reduce="x => x.value"
                  label="label"
                  class="tasks-per-page-select"
                  style="min-width: 80px; max-width: 100px;"
                  :clearable="false"
                />
              </div>
            </div>
          </template>
          <template slot="thead">
            <vs-th v-if="showGripColumn" class="grip-col"></vs-th>
            <vs-th>Actions</vs-th>
            <vs-th sort-key="TaskName" class="cursor-pointer">Task</vs-th>
            <vs-th sort-key="Description" class="cursor-pointer tasks-desc-col">Description</vs-th>
            <vs-th v-if="editPriorityMode" sort-key="UserPriority" class="cursor-pointer">Priority</vs-th>
            <vs-th v-if="showAllTasks" sort-key="AssignedToID" class="cursor-pointer">Assigned To</vs-th>
            <vs-th sort-key="ClientName" class="cursor-pointer">Client</vs-th>
            <vs-th sort-key="SOWID" class="cursor-pointer">SOW</vs-th>
            <vs-th sort-key="CategoryName" class="cursor-pointer">Category</vs-th>
            <vs-th sort-key="CreateDate" class="cursor-pointer">Created Dt</vs-th>
            <vs-th sort-key="HoursLogged" class="cursor-pointer">Time</vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr
              :data="task"
              :key="task.SOWLineItemID || task.TaskID || indextr"
              :data-sow-line-item-id="task.SOWLineItemID"
              v-for="(task, indextr) in data"
              class="task-row-clickable"
              @click.native="OpenTaskDetail(task)"
            >
              <vs-td v-if="showGripColumn" class="grip-handle" style="padding: 0;padding-left: 5px;" @click.stop.native>
                <div class="grip-handle-button" style="display: inline-flex; align-items: center; justify-content: center;">
                  <feather-icon icon="MenuIcon" svgClasses="w-4 h-4" />
                </div>
              </vs-td>
              <vs-td @click.stop.native>
                <div v-if="task.CompleteDate == null" class="flex items-center">
                  <vx-tooltip text="Mark Completed" position="top">
                    <vs-button @click.stop="BeginMarkComplete(task)" size="small" color="success" icon-pack="feather" icon="icon-check" :disabled="(currentTaskID == task.TaskID && task.TaskID != null) || (currentSOWLineItemID == task.SOWLineItemID && task.SOWLineItemID != null)" class="mr-1" />
                  </vx-tooltip>
                  <vx-tooltip :text="clockInTooltip(task)" position="top">
                    <vs-button
                      @click.stop="ClockInTask(task)"
                      size="small"
                      icon-pack="feather"
                      icon="icon-clock"
                      :disabled="(currentTaskID == task.TaskID && task.TaskID != null) || (currentSOWLineItemID == task.SOWLineItemID && task.SOWLineItemID != null) || !canClockIn(task)" />
                  </vx-tooltip>
                </div>
                <vx-tooltip v-else text="Task Completed" position="top">
                  <vs-button size="small" color="success" icon-pack="feather" icon="icon-check" disabled />
                </vx-tooltip>
              </vs-td>
              <vs-td :data="task.TaskName">
                <div>{{ task.TaskName }}</div>
              </vs-td>
              <vs-td :data="GetTaskDescription(task)" class="tasks-desc-col">
                <vx-tooltip v-if="GetTaskDescription(task)" :text="GetTaskDescription(task)" position="top">
                  <div class="tasks-desc-cell">{{ GetTaskDescription(task) }}</div>
                </vx-tooltip>
                <div v-else class="tasks-desc-cell">—</div>
              </vs-td>
              <vs-td v-if="editPriorityMode" :data="task.UserPriority">{{ task.UserPriority || '—' }}</vs-td>
              <vs-td v-if="showAllTasks" :data="GetAssignedToName(task)">{{ GetAssignedToName(task) || '—' }}</vs-td>
              <vs-td :data="task.ClientName">{{ task.ClientName }}</vs-td>
              <vs-td :data="GetSOWName(task)" @click.stop.native>
                <a v-if="task.SOWID" href="#" @click.prevent.stop="OpenSOWFromTask(task)" class="text-primary cursor-pointer">
                  <vx-tooltip v-if="GetSOWNumber(task)" :text="GetSOWNumber(task)" position="top">
                    <span>{{ GetSOWName(task) }}</span>
                  </vx-tooltip>
                  <span v-else>{{ GetSOWName(task) }}</span>
                </a>
                <template v-else>
                  <vx-tooltip v-if="GetSOWNumber(task)" :text="GetSOWNumber(task)" position="top">
                    <span>{{ GetSOWName(task) }}</span>
                  </vx-tooltip>
                  <span v-else>{{ GetSOWName(task) }}</span>
                </template>
              </vs-td>
              <vs-td :data="task.CategoryName">{{ task.CategoryName }}</vs-td>
              <vs-td :data="task.CreateDate">{{ FormatDate(task.CreateDate) }}</vs-td>
              <vs-td :data="task.HoursLogged">
                <div>{{ task.HoursLogged.toFixed(1) }} / {{ task.TimeEstimate.toFixed(1) }}</div>
                <vs-progress :percent="task.HoursLogged / task.TimeEstimate * 100" :color="GetBarColor(task.HoursLogged / task.TimeEstimate * 100)"></vs-progress>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>

     <vs-prompt
      title="Mark Task Complete"
      color="primary"
      :active.sync="completeModalOpen"
      @accept="FinishMarkTaskComplete"
    >
      <div>
        Mark task as completed?
      </div>
      <div>
        Further editing of the task will not be allowed.
      </div>
      <!-- <vs-textarea class="mt-2" height="10rem" label="Note"></vs-textarea>
      <vs-textarea class="mt-2" height="10rem" label="Description"></vs-textarea> -->

    </vs-prompt>

    <!-- Confirm Clock Out -->
      <!-- Confirm Clock Out -->
    <vs-prompt
      title="Add New Task"
      :active.sync="addTaskModal"
      :buttons-hidden="true"
      prevent-close
    >
      <div>
        <label>Client: <span class="text-danger">*</span></label>
        <v-select placeholder="Client" class="mb-2" v-model="addTaskData.ClientID" :options="addTaskClientList" :reduce="x => x.ClientID" label="ClientName"></v-select>
        <label>SOW: <span class="text-danger">*</span></label>
        <div class="flex items-end mb-2">
          <v-select placeholder="SOW" v-model="addTaskData.SOWID" :options="sowListForClient" :reduce="x => x.SOWID" label="SOWName" :class="{ dropdownDisabled: addTaskData.ClientID == null }" class="flex-grow"/>
          <vs-button v-if="isAdmin" @click="BeginCreateSOW" icon-pack="feather" icon="icon-plus" class="ml-2"></vs-button>
        </div>
        <label>Task Name: <span class="text-danger">*</span></label>
        <vs-input v-model="addTaskData.TaskName" class="mb-2"></vs-input>
        <label>Estimate</label>
        <vs-input type="number" v-model.number="addTaskData.TimeEstimate" class="mb-2"></vs-input>
        <div class="flex justify-end mt-3">
          <vs-button @click="AcceptNewTask" :disabled="savingNewTask || !taskValid" color="primary">{{ savingNewTask ? 'Saving...' : 'Save' }}</vs-button>
          <vs-button @click="addTaskModal = false" :disabled="savingNewTask" type="flat" color="secondary" class="ml-2">Cancel</vs-button>
        </div>
      </div>
    </vs-prompt>

    <SOWModal ref="sowModal" :base-layer="1" :default-client-id="addTaskData.ClientID" @saved="OnSOWCreatedFromTasks" />

    <vs-prompt
      class="task-detail-prompt"
      title="Task Details"
      :active.sync="taskDetailModalOpen"
      :buttons-hidden="true"
    >
      <div class="task-detail-prompt-content">
        <div class="task-detail-prompt-body">
          <div v-if="selectedTaskDetail" class="task-detail-modal">
            <h4 class="task-detail-title">{{ selectedTaskDetail.TaskName || '—' }}</h4>
            <div class="task-detail-row">
              <span class="task-detail-label">Priority</span>
              <span>{{ selectedTaskDetail.UserPriority || '—' }}</span>
            </div>
            <div class="task-detail-row" v-if="showAllTasks">
              <span class="task-detail-label">Assigned To</span>
              <span>{{ GetAssignedToName(selectedTaskDetail) || '—' }}</span>
            </div>
            <div class="task-detail-row">
              <span class="task-detail-label">Client</span>
              <span>{{ selectedTaskDetail.ClientName || '—' }}</span>
            </div>
            <div class="task-detail-row">
              <span class="task-detail-label">SOW</span>
              <span>
                <a
                  v-if="selectedTaskDetail.SOWID"
                  href="#"
                  @click.prevent.stop="OpenSOWFromTask(selectedTaskDetail)"
                  class="text-primary"
                >{{ GetSOWName(selectedTaskDetail) || '—' }}</a>
                <template v-else>{{ GetSOWName(selectedTaskDetail) || '—' }}</template>
              </span>
            </div>
            <div class="task-detail-row">
              <span class="task-detail-label">Category</span>
              <span>{{ selectedTaskDetail.CategoryName || '—' }}</span>
            </div>
            <div class="task-detail-row">
              <span class="task-detail-label">Created</span>
              <span>{{ FormatDate(selectedTaskDetail.CreateDate) }}</span>
            </div>
            <div class="task-detail-row">
              <span class="task-detail-label">Time</span>
              <span>{{ selectedTaskDetail.HoursLogged.toFixed(1) }} / {{ selectedTaskDetail.TimeEstimate.toFixed(1) }} hrs</span>
            </div>
            <div class="task-detail-row">
              <span class="task-detail-label">Status</span>
              <span>{{ selectedTaskDetail.CompleteDate == null ? 'Open' : 'Completed' }}</span>
            </div>
            <div class="task-detail-description">
              <span class="task-detail-label">Description</span>
              <p class="task-detail-description-text">{{ GetTaskDescription(selectedTaskDetail) || '—' }}</p>
            </div>
          </div>
        </div>
        <div class="task-detail-prompt-footer">
          <vs-button @click="taskDetailModalOpen = false" color="primary">Close</vs-button>
        </div>
      </div>
    </vs-prompt>

    </div>
</template>

<script>
import Sortable from 'sortablejs'
import TasksSidebar         from './TasksSidebar.vue'
import TasksItem            from './TasksItem.vue'
import VuePerfectScrollbar  from 'vue-perfect-scrollbar'
import moduleTasks          from '@/store/tasks/moduleTasks.js'
import flatPickr            from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
import SOWModal from '@/components/SOWModal.vue'
const moment = require('moment')

export default {
  data () {
    return {
      selectedMails        : [],
      isSidebarActive      : false,
      showThread           : false,
      clickNotClose        : true,
      isTasksSidebarActive : true,
      settings             : {
        maxScrollbarLength : 60,
        wheelSpeed         : 0.30
      },
      currentTask: {
        active: true,
        task: {}
      },
      clockOutPromptData:{
        active: false
      },
      configdateTimePicker: {
        enableTime: true,
        dateFormat: 'd-m-Y H:i' //'d-m-Y H:i K'
      },
      clientID: null,
      projectID: null,
      showCompleted: false,
      tasksPerPage: 50,
      tasksPerPageOptions: [
        { value: 99999, label: 'All' },
        { value: 10, label: '10' },
        { value: 25, label: '25' },
        { value: 50, label: '50' },
        { value: 100, label: '100' }
      ],
      addTaskModal: false,
      addTaskData: {},
      savingNewTask: false,
      completeModalOpen: false,
      taskCompleting: null,
      taskDetailModalOpen: false,
      selectedTaskDetail: null,
      showAllTasks: false,
      editPriorityMode: false,
      sortKey: 'UserPriority',
      sortDesc: false,
      sortableInstance: null,
      gradientStart: '#cc67f0',
      gradientEnd: '#7367f0',
    }

  },
  watch: {
    showAllTasks(val) {
      if (val) this.editPriorityMode = false
    },
    clientID(newVal) {
      if (this.editPriorityMode && newVal != null) this.editPriorityMode = false
    },
    sortKey(newVal) {
      if (this.editPriorityMode && newVal !== 'UserPriority') this.editPriorityMode = false
    },
    sortDesc(newVal) {
      if (this.editPriorityMode && newVal) this.editPriorityMode = false
    },
    simulation (val) {
      this.GetTasks()
    },
    userLoggedIn (loggedIn) {
      if (loggedIn) {
        this.OnLoggedIn()
      }
    },
    isSidebarActive (value) {
      if (!value) this.showThread = false
    },
    windowWidth () {
      this.setSidebarWidth()
    },
  },
  computed: {
    effectiveTasksPerPage() {
      return this.tasksPerPage === 99999 ? (this.sortedTaskList && this.sortedTaskList.length) || 99999 : this.tasksPerPage
    },
    currentTimeEntry() {
      return this.$store.getters.GetCurrentTimeEntry
    },
    currentSOWLineItemID() {
      if (this.currentTimeEntry == null) {
        return null
      }
      return this.currentTimeEntry.SOWLineItemID
    },
    currentTaskID() {
      if (this.currentTimeEntry == null) {
        return null
      }
      return this.currentTimeEntry.TaskID
    },
    taskValid() {
      if (this.addTaskData.ClientID == null) return false
      if (this.addTaskData.SOWID == null) return false
      if (!this.addTaskData.TaskName || String(this.addTaskData.TaskName).trim() === '') return false
      return true
    },
    sowListForClient() {
      if (this.addTaskData.ClientID == null) return []
      return this.sowList.filter(x => x.ClientID === this.addTaskData.ClientID)
    },
    addTaskClientList() {
      return this.$store.getters.GetClientList
    },
    categoryList() {
      if (this.addTaskData.ClientID == null) return []
      return this.$store.getters.GetCategoryList.filter(x => x.ClientID == this.addTaskData.ClientID)
    },
    simulation () {
      return this.$store.getters.GetSimulation
    },
    clientList() {
			return this.$store.getters.GetClientList.filter(x => {
        return this.taskList.find(y => y.ClientID == x.ClientID) != null
      })
    },
    projectList() {
      return this.$store.getters.GetProjectList
    },
    filteredProjectList() {
      if (this.clientID == null || this.clientID == 0) {
        return this.projectList
      }
      return this.projectList.filter(x => (x.ITATInfo && x.ITATInfo.ClientID === this.clientID) || x.ClientID === this.clientID)
    },
    isAdmin () {
      return this.$store.getters.GetIsAdmin
    },
    workerList () {
      return this.$store.getters.GetWorkerList
    },
    validEntry () {
      return true
    },
    userLoggedIn () {
      return this.$store.getters.GetUserLoggedIn
    },
    selectedProjectID () {
      return this.$store.getters.GetSelectedProjectID
    },
    tasksCardTitle () {
      return this.showAllTasks ? 'All Tasks' : 'My Tasks'
    },
    taskList () {
      return this.showAllTasks ? this.$store.getters.GetAllTaskList : this.$store.getters.GetMyTaskListV2
    },
    sowList () {
      return this.$store.getters.GetSOWList
    },
    taskListFiltered() {
      let y = []
      if (this.clientID == null) {
        y = this.taskList.filter(x => this.showCompleted ? true : x.CompleteDate == null)
      } else {
        y = this.taskList.filter(x => x.ClientID == this.clientID).filter(x => this.showCompleted ? true : x.CompleteDate == null)
      }
      return y
    },
    showGripColumn() {
      return !this.showAllTasks && this.editPriorityMode && this.sortKey === 'UserPriority' && this.sortDesc === false
    },
    sortedTaskList() {
      const list = [...this.taskListFiltered]
      const key = this.sortKey
      const desc = this.sortDesc
      const uv = x => (x.UserPriority != null && String(x.UserPriority).trim() !== '') ? String(x.UserPriority) : ''
      const cv = (x) => {
        if (key === 'UserPriority') return uv(x)
        const v = x[key]
        if (v == null) return ''
        if (key === 'CreateDate') return new Date(v).getTime()
        return v
      }
      list.sort((a, b) => {
        const va = cv(a)
        const vb = cv(b)
        if (va < vb) return desc ? 1 : -1
        if (va > vb) return desc ? -1 : 1
        return 0
      })
      return list
    },
    workerID () {
      return this.$store.getters.GetWorkerID
    },
    windowWidth () {
      return this.$store.state.windowWidth
    }
  },
  methods: {
    HexToRGB(h) {
      let r = 0, g = 0, b = 0
      if (h.length == 4) {
        r = '0x' + h[1] + h[1]
        g = '0x' + h[2] + h[2]
        b = '0x' + h[3] + h[3]
      } else if (h.length == 7) {
        r = '0x' + h[1] + h[2]
        g = '0x' + h[3] + h[4]
        b = '0x' + h[5] + h[6]
      }
      return { r: parseInt(r, 16), g: parseInt(g, 16), b: parseInt(b, 16) }
    },
    RGBToHex(r, g, b) {
      r = Math.round(r).toString(16).split('.')[0]
      g = Math.round(g).toString(16).split('.')[0]
      b = Math.round(b).toString(16).split('.')[0]
      if (r.length == 1) r = '0' + r
      if (g.length == 1) g = '0' + g
      if (b.length == 1) b = '0' + b
      return '#' + r + g + b
    },
    Lerp(a, b, t) {
      return a * (1 - t) + b * t
    },
    LerpColor(a, b, amount) {
      const rgb1 = this.HexToRGB(a)
      const rgb2 = this.HexToRGB(b)
      rgb1.r = this.Lerp(rgb1.r, rgb2.r, amount)
      rgb1.g = this.Lerp(rgb1.g, rgb2.g, amount)
      rgb1.b = this.Lerp(rgb1.b, rgb2.b, amount)
      return this.RGBToHex(rgb1.r, rgb1.g, rgb1.b)
    },
    async FinishMarkTaskComplete() {
      console.log(this.taskCompleting)
      await this.$store.dispatch('ActionMarkTaskComplete', {
        taskId: this.taskCompleting.TaskID,
        sowLineItemId: this.taskCompleting.SOWLineItemID
      })
      this.GetTasks()
    },
    GetBarColor (percent) {
      if (percent <= 80) {
        return 'success'
      } else if (percent <= 100) {
        return 'warning'
      }
      return 'danger'
    },
    FormatDate(date) {
      return moment(date).format('M/DD/YYYY')
    },
    GetTaskDescription(task) {
      if (!task || task.Description == null) return ''
      const text = String(task.Description).trim()
      return text
    },
    OpenTaskDetail(task) {
      this.selectedTaskDetail = task
      this.taskDetailModalOpen = true
    },
    GetSOWName(task) {
      if (task.SOWID == null) return ''
      const sow = this.sowList.find(x => x.SOWID === task.SOWID)
      return sow ? sow.SOWName : ''
    },
    GetSOWNumber(task) {
      if (task.SOWID == null) return ''
      const sow = this.sowList.find(x => x.SOWID === task.SOWID)
      return sow ? (sow.SOWNumber || '') : ''
    },
    OpenSOWFromTask (task) {
      if (!task || task.SOWID == null) return
      const sow = this.sowList.find(x => x.SOWID === task.SOWID)
      if (sow && this.$refs.sowModal) {
        this.$refs.sowModal.OpenForSOW(sow)
      }
    },
    GetAssignedToName(task) {
      const id = task.AssignedToID != null ? task.AssignedToID : task.WorkerID
      if (id == null) return ''
      const w = this.workerList.find(x => x.ITATInfo && x.ITATInfo.WorkerID === id)
      return w && w.ITATInfo ? w.ITATInfo.WorkerName : ''
    },
    canClockIn(task) {
      if (!this.showAllTasks) return true
      const id = task.AssignedToID != null ? task.AssignedToID : task.WorkerID
      if (id == null) return false
      return id === this.workerID
    },
    clockInTooltip(task) {
      if ((this.currentTaskID == task.TaskID && task.TaskID != null) || (this.currentSOWLineItemID == task.SOWLineItemID && task.SOWLineItemID != null)) return 'Clocked In'
      if (!this.canClockIn(task)) return 'Not assigned to you'
      return 'Clock In'
    },
    OnToggleAllTasks() {
      if (this.showAllTasks) this.$store.dispatch('ActionFetchAllTaskList')
    },
    BeginMarkComplete(task) {
      console.log('completing task', task)
      this.taskCompleting = task
      this.completeModalOpen = true
    },
    ClockInTask(task) {
      const currentTime = moment().format('hh:mm A')
      const currentDate = moment().format('Y-MM-DD')

      this.$store.dispatch('ActionSetTimeEntryPrompt', {
        active: true,
        title: 'Clock In',
        // taskName: null,
        taskID: task.TaskID,
        itatTaskID: task.TaskID,
        // clientName: 'ITAT Internal',
        clientID: task.ClientID,
        categoryID: task.CategoryID,
        // clientCategory: 'Client Category',
        startTime: currentTime,
        startDate: currentDate,
        endTime: null,
        endDate: null,
        description: (task.TaskNote != null && task.TaskNote !== '') ? task.TaskNote : (task.TaskName || ''),
        error: 'Fields cannot be empty.',
        action: 'create', //create, clockin, finish
        mileage: 0,
        sowID: task.SOWID,
        sowLineItemID: task.SOWLineItemID,
      })
    },
    BeginAddTask() {
      const internal = this.$store.getters.GetClientList.find(x => x.ClientName === 'ITAT - Internal')
      this.addTaskModal = true
      this.addTaskData = {
        ClientID: internal ? internal.ClientID : null,
        SOWID: 0,
        TaskName: '',
        TimeEstimate: null
      }
    },
    async AcceptNewTask() {
      if (this.savingNewTask || !this.taskValid) return
      this.savingNewTask = true
      try {
        await this.$store.dispatch('ActionCreateLineItem', {
          SOWID: this.addTaskData.SOWID,
          Title: String(this.addTaskData.TaskName).trim(),
          TimeEstimate: this.addTaskData.TimeEstimate != null ? this.addTaskData.TimeEstimate : 0,
          IsCompleted: false,
          AssignedTo: this.workerID
        })
        this.addTaskModal = false
        this.$store.dispatch('ActionFetchMyTaskListV2')
        this.$store.dispatch('ActionFetchMySOWLineItems')
      } catch (error) {
        this.addTaskModal = true
        const message = error && error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Unable to save task. Please review and try again.'
        this.$vs.notify({
          color: 'danger',
          title: 'Save failed',
          text: message
        })
      } finally {
        this.savingNewTask = false
      }
    },
    BeginCreateSOW () {
      if (this.$refs.sowModal) {
        this.$refs.sowModal.OpenForCreate()
      }
    },
    OnSOWCreatedFromTasks (savedSOW) {
      if (!savedSOW || savedSOW.SOWID == null) return
      this.$store.dispatch('ActionFetchSOWs')
      this.$store.dispatch('ActionFetchMySOWLineItems')
      if (savedSOW.ClientID != null) {
        this.$set(this.addTaskData, 'ClientID', savedSOW.ClientID)
      }
      this.$set(this.addTaskData, 'SOWID', savedSOW.SOWID)
    },
    OnChangedProject(p) {
      if (p == null) return
      const project = this.projectList.find(x => x.id && x.id.toString() == p.toString())
      if (project != null && (project.ITATInfo && project.ITATInfo.ClientID != null || project.ClientID != null)) {
        this.clientID = (project.ITATInfo && project.ITATInfo.ClientID) || project.ClientID
      }
    },
    OnChangedClient(c) {
      if (c == null) {
        this.projectID = null
      }
    },
    setSort(key) {
      if (this.sortKey === key) this.sortDesc = !this.sortDesc
      else { this.sortKey = key; this.sortDesc = false }
    },
    ToggleEditPriority() {
      if (this.editPriorityMode) {
        this.editPriorityMode = false
        return
      }
      this.BeginEditPriority()
    },
    BeginEditPriority() {
      this.clientID = null
      this.sortKey = 'UserPriority'
      this.sortDesc = false
      this.editPriorityMode = true
    },
    initSortable() {
      if (this.sortableInstance) return
      const el = this.$refs.tasksTable && this.$refs.tasksTable.$el && this.$refs.tasksTable.$el.querySelector && this.$refs.tasksTable.$el.querySelector('table')
      if (!el) return
      this.sortableInstance = Sortable.create(el, {
        draggable: 'tr',
        filter: 'thead tr',
        handle: '.grip-handle',
        animation: 10,
        scrollSensitivity: 80,
        chosenClass: 'task-row-dragging',
        forceFallback: true,
        fallbackClass: 'task-row-fallback',
        onStart: () => {
          document.body.classList.add('tasks-sortable-dragging')
          this._sortableWheelHandler = (e) => {
            let el = e.target
            while (el && el !== document.body) {
              const style = window.getComputedStyle(el)
              if (el.scrollHeight > el.clientHeight && /auto|scroll|overlay/.test(style.overflowY)) {
                el.scrollTop += e.deltaY
                e.preventDefault()
                return
              }
              el = el.parentElement
            }
            const root = document.scrollingElement || document.documentElement
            root.scrollTop += e.deltaY
            e.preventDefault()
          }
          document.addEventListener('wheel', this._sortableWheelHandler, { capture: true, passive: false })
        },
        onEnd: (evt) => {
          document.body.classList.remove('tasks-sortable-dragging')
          if (this._sortableWheelHandler) {
            document.removeEventListener('wheel', this._sortableWheelHandler, { capture: true })
            this._sortableWheelHandler = null
          }
          const movedEl = evt.item
          const movedId = movedEl && movedEl.getAttribute && movedEl.getAttribute('data-sow-line-item-id')
          if (movedId == null || movedId === '') return
          const prev = movedEl.previousElementSibling
          const afterSowLineItemId = prev && prev.getAttribute ? (prev.getAttribute('data-sow-line-item-id') || null) : null
          const afterIdNum = afterSowLineItemId !== null && afterSowLineItemId !== '' ? parseInt(afterSowLineItemId, 10) : null
          this.$store.dispatch('ActionUpdateTaskPriority', { sowLineItemId: parseInt(movedId, 10), afterSowLineItemId: afterIdNum }).then(() => this.GetTasks())
        }
      })
    },
    destroySortable() {
      if (this.sortableInstance) {
        this.sortableInstance.destroy()
        this.sortableInstance = null
      }
    },
    GetTasks() {
      if (this.showAllTasks) this.$store.dispatch('ActionFetchAllTaskList')
      else this.$store.dispatch('ActionFetchMyTaskListV2')
    },
    OnLoggedIn () {
      this.GetTasks()
    },
    closTaskViewSidebar () {
      this.isSidebarActive = false
    },
    setSidebarWidth () {
      if (this.windowWidth < 992) {
        this.isTasksSidebarActive = this.clickNotClose = false
      } else {
        this.isTasksSidebarActive = this.clickNotClose = true
      }
    },
    toggleTasksSidebar (value = false) {
      if (!value) {
        this.closTaskViewSidebar()
        if (this.clickNotClose) {
          return
        }
      }
      this.isTasksSidebarActive = value
    },
    ErrorClockIn () {
      this.$vs.notify({
        color: 'danger',
        title: 'Error',
        text: 'You must clock out before clocking in!'
      })
    }
  },
  components: {
    TasksItem,
    TasksSidebar,
    VuePerfectScrollbar,
    flatPickr,
    vSelect,
    SOWModal
  },
  created () {

    this.setSidebarWidth()
  },
  beforeDestroy() {
    this.destroySortable()
  },
  mounted() {
    if (this.userLoggedIn) this.OnLoggedIn()
  },
  updated() {
    if (this.showGripColumn) {
      this.$nextTick(() => this.initSortable())
    } else {
      this.destroySortable()
    }
  }
}

</script>


<style lang="scss">
@import "@/assets/scss/vuexy/apps/tasks.scss";
.tasks-card .vx-card__body {
  padding-top: 0;
}
.grip-handle {
  cursor: grab;
}
.grip-handle-button {
  min-width: 2.2rem;
  min-height: 2.2rem;
  padding: 0.35rem;
}
.tasks-card .tasks-desc-col {
  max-width: 14rem;
  width: 14rem;
}
.tasks-card .tasks-desc-cell {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.tasks-card .task-row-clickable {
  cursor: pointer;
}
.task-detail-prompt.vs-dialog-primary .vs-dialog {
  max-width: 42rem !important;
}
.task-detail-prompt-content {
  display: flex;
  flex-direction: column;
}
.task-detail-prompt-body {
  max-height: min(75vh, 36rem);
  overflow-y: auto;
  overscroll-behavior: contain;
  padding-right: 0.25rem;
}
.task-detail-prompt-footer {
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}
.theme-dark .task-detail-prompt-footer {
  border-top-color: rgba(255, 255, 255, 0.12);
}
.task-detail-modal .task-detail-title {
  margin: 0 0 1rem;
  font-size: 1.1rem;
  font-weight: 600;
  line-height: 1.35;
  word-break: break-word;
}
.task-detail-modal .task-detail-row {
  display: flex;
  gap: 0.75rem;
  margin-bottom: 0.5rem;
}
.task-detail-modal .task-detail-label {
  flex: 0 0 6rem;
  font-weight: 600;
}
.task-detail-modal .task-detail-description {
  margin-top: 0.75rem;
}
.task-detail-modal .task-detail-description-text {
  margin: 0.35rem 0 0;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>

<style lang="scss">
body.tasks-sortable-dragging {
  cursor: grabbing;
}
body.tasks-sortable-dragging .vx-navbar-wrapper {
  pointer-events: none;
}
body.tasks-sortable-dragging .teTable tr.task-row-dragging {
  transform: scale(1.02);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
  border: 2px solid rgba(var(--vs-primary), 0.8) !important;
  background: rgba(var(--vs-primary), 0.2) !important;
  z-index: 10 !important;
  position: relative;
}
body.tasks-sortable-dragging .teTable tr.task-row-dragging td {
  background: transparent !important;
}
.task-row-fallback {
  opacity: 0 !important;
  pointer-events: none !important;
}
</style>

<style lang="css">
.flaggedMyTask h5{
  color: #ffd371 !important;
}
.flaggedMyTask h5 > span{
  color: #ffd371 !important;
}
</style>